import { Map } from '_core/components/Map';

export default Map;
